export enum Restrictions {
  RetailerRestriction = 'RETAILER',
  UserRestriction = 'USER',
  MarketsRestriction = 'MARKET'
}
